module.exports = __webpack_public_path__ + "img/s-c.92097f45.jpg";